const copyStylesheets = (sourceDocument, targetDocument) => {
  const stylesheets = sourceDocument.querySelectorAll(
    'link[rel="stylesheet"], style',
  );

  if (stylesheets.length === 0) {
    throw new Error("No stylesheets found to copy to the print window.");
  }

  const loadPromises = [];

  stylesheets.forEach((stylesheet) => {
    if (stylesheet.tagName.toLowerCase() === "link") {
      const link = targetDocument.createElement("link");
      link.rel = "stylesheet";
      link.href = stylesheet.href;
      loadPromises.push(
        new Promise((resolve, reject) => {
          link.onload = resolve;
          link.onerror = () =>
            reject(new Error(`Failed to load stylesheet: ${link.href}`));
          targetDocument.head.appendChild(link);
        }),
      );
      return;
    }

    const style = targetDocument.createElement("style");
    style.textContent = stylesheet.textContent;
    targetDocument.head.appendChild(style);
  });

  return Promise.all(loadPromises);
};

export default copyStylesheets;
